"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BannerImage2 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig2.avif";
import BannerImage3 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig3.avif";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";
import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import { fragenAutoOhneZulassungVerkaufen } from "./data";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function AutoOhneZulassungVerkaufen() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Auto ohne Zulassung verkaufen – sicher und stressfrei"
        link="/guides/auto-ohne-zulassung-verkaufen"
        linkname="Auto ohne Zulassung verkaufen"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung für dein Auto ohne
            Zulassung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Kann ich mein Fahrzeug ohne Fahrzeugschein verkaufen?"
              leftText={
                <>
                  <p>
                    Der Verkauf eines abgemeldeten Autos kann sowohl für Käufer
                    als auch Verkäufer Vorteile bringen, stellt aber auch
                    besondere Anforderungen. Während die Abmeldung den
                    bisherigen Halter vor weiteren Kosten und Haftungsrisiken
                    schützt, erschwert sie potenziellen Interessenten eine
                    Probefahrt und den sicheren Transport. In diesem umfassenden
                    Leitfaden erfährst du, wann sich der Verkauf ohne Zulassung
                    lohnt, wie der Ablauf funktioniert, welche rechtlichen
                    Aspekte beachtet werden müssen und wie du trotz fehlender
                    Kennzeichen einen fairen Preis erzielst.
                  </p>
                </>
              }
              rightFirstTitle="Warum ein Auto ohne Zulassung verkaufen?"
              rightFirstText={
                <>
                  <p>
                    Wenn du dein Auto vor dem Verkauf abmeldest, erlischt deine
                    Halterpflicht sofort. Das bedeutet:
                  </p>
                  <ul className="custom-unordered-list">
                    <li>
                      <strong>Keine Haftung:</strong> Ordnungswidrigkeiten,
                      Steuern und Versicherungsrisiken gehen direkt auf den
                      Käufer über.
                    </li>
                    <li>
                      <strong>Keine laufenden Kosten:</strong> Du sparst
                      Kfz-Steuer und Versicherungsprämien ab dem Tag der
                      Abmeldung.
                    </li>
                    <li>
                      <strong>Sicherheit:</strong> Bei einer Probefahrt musst du
                      nicht befürchten, dass dein Kennzeichen missbraucht wird.
                    </li>
                  </ul>

                  <p>Gleichzeitig gibt es Nachteile:</p>
                  <ul className="custom-unordered-list">
                    <li>
                      <strong>Keine Probefahrt:</strong> Ohne Kennzeichen darf
                      das Auto nicht auf öffentlichen Straßen bewegt werden. Das
                      schreckt manche Käufer ab.
                    </li>
                    <li>
                      <strong>Transportaufwand:</strong> Das Fahrzeug muss per
                      Anhänger oder Spedition übergeben werden, was zusätzliche
                      Kosten verursacht.
                    </li>
                    <li>
                      <strong>Vertrauensproblem:</strong> Ein angemeldetes Auto
                      vermittelt oft mehr Vertrauen, weil der Käufer sicher sein
                      kann, dass es fahrbereit ist.
                    </li>
                  </ul>

                  <p>
                    <strong>Wann lohnt sich die Abmeldung?</strong> Bei Autos,
                    die nicht mehr verkehrssicher sind, sich kaum noch bewegen
                    lassen oder wenn der Verkäufer bereits ein neues Fahrzeug
                    hat und keine doppelten Kosten tragen will.
                  </p>
                </>
              }
              rightSecondTitle="Rechtliche Grundlagen und Ablauf der Abmeldung"
              rightSecondText={
                <>
                  <p>
                    Die Abmeldung erfolgt bei einer Zulassungsstelle – in
                    Österreich ist das bei jeder Zulassungsstelle im ganzen
                    Bundesgebiet möglich. Eine reine Online-Abmeldung gibt es
                    hier nicht: Die Unterlagen und die Kennzeichentafeln müssen
                    vorgelegt werden. Du benötigst:
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>Zulassungsbescheinigung (beide Teile)</li>
                    <li>
                      Genehmigungsnachweis (z. B. Typenschein oder
                      Einzelgenehmigung)
                    </li>
                    <li>Kennzeichentafeln</li>
                    <li>
                      Amtlichen Lichtbildausweis (z. B. Reisepass oder
                      Führerschein)
                    </li>
                  </ul>

                  <p>
                    Für die Abmeldung fallen keine Gebühren an. Mit einer
                    schriftlichen Vollmacht kann auch eine Vertreterin oder ein
                    Vertreter das Fahrzeug für dich abmelden. Nach der Abmeldung
                    erhältst du eine Bestätigung. Hebe diese auf, denn sie
                    belegt, dass das Fahrzeug nicht mehr auf dich zugelassen
                    ist.
                  </p>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage3}
                revert
                isBig
                fontSize="36px"
                title="Der Verkaufsprozess Schritt für Schritt"
                alt="Abgemeldetes Auto verkaufen - Schritt-für-Schritt-Anleitung"
                text={
                  <>
                    <ol className="custom-ordered-list">
                      <li>
                        <strong>Marktwert bestimmen:</strong>{" "}
                        Auch abgemeldete Fahrzeuge haben einen Wert.
                        Berücksichtige Alter, Kilometerstand, Zustand und
                        Ausstattung. Vergleiche ähnliche Fahrzeuge und nutze
                        Online-Bewertungstools, um eine realistische
                        Preisvorstellung zu bekommen. Defekte oder Unfälle
                        mindern den Wert, aber durch Transparenz schaffst du
                        Vertrauen.
                      </li>
                      <li>
                        <strong>Dokumente vorbereiten:</strong>{" "}
                        Neben Fahrzeugschein, Fahrzeugbrief und dem
                        Abmeldebescheid solltest du folgende Unterlagen
                        bereithalten:
                        <ul className="custom-unordered-list secondary">
                          <li>
                            Prüfbericht der letzten Hauptuntersuchung (Pickerl)
                          </li>
                          <li>Serviceheft und Reparaturrechnungen</li>
                          <li>
                            Betriebsanleitung und alle verfügbaren Schlüssel
                          </li>
                          <li>
                            Kaufvertrag (standardisiert), in dem der abgemeldete
                            Zustand festgehalten wird
                          </li>
                        </ul>
                        Falls die Hauptuntersuchung abgelaufen ist, weise darauf
                        hin. Manche Käufer sehen darin einen
                        Preisverhandlungshebel, andere planen ohnehin eine
                        umfassende Reparatur.
                      </li>
                      <li>
                        <strong>Käufer finden:</strong>{" "}
                        Deine Zielgruppe sind:
                        <ul className="custom-unordered-list secondary">
                          <li>
                            Schrauber und Bastler, die Autos günstig kaufen und
                            selbst instand setzen.
                          </li>
                          <li>
                            Händler, die Fahrzeuge im Auftrag reparieren und
                            weiterverkaufen.
                          </li>
                          <li>
                            Sammler, falls es sich um ein seltenes Modell
                            handelt.
                          </li>
                          <li>Autoverwerter, die Teile ausschlachten.</li>
                        </ul>
                        Bewirb dein Auto offen als „abgemeldet“ und schildere
                        den Zustand detailliert. Nutze Fotos aus vielen
                        Perspektiven – auch von Mängeln.
                      </li>
                      <li>
                        <strong>Besichtigung organisieren:</strong>{" "}
                        Da keine Probefahrt möglich ist, ist die Besichtigung
                        umso wichtiger. Vereinbare einen neutralen Treffpunkt,
                        lass dir einen Ausweis zeigen und erläutere den
                        technischen Zustand. Biete an, dass der Käufer einen
                        Fachmann mitbringt. Transparenz schafft Vertrauen.
                      </li>
                      <li>
                        <strong>Transport klären:</strong>{" "}
                        Da abgemeldete Autos nicht am öffentlichen Verkehr
                        teilnehmen dürfen, braucht der Käufer:
                        <ul className="custom-unordered-list secondary">
                          <li>
                            Kurzzeitkennzeichen (max. 5 Tage) oder rote
                            Händlerkennzeichen
                          </li>
                          <li>einen Anhänger oder Transporter</li>
                        </ul>
                        Viele Händler übernehmen den Transport. Private Käufer
                        müssen sich vorab um Zulassung oder Transportmittel
                        kümmern. Alternativ kannst du den Transport gegen Gebühr
                        organisieren – das erhöht die Kaufbereitschaft.
                      </li>
                      <li>
                        <strong>Zahlung und Übergabe:</strong>{" "}
                        Verwende einen Kaufvertrag, in dem alle Details
                        festgehalten sind: Kaufpreis, Fahrzeugzustand, fehlende
                        Zulassung, Übergabedatum. Bestehe auf einer sicheren
                        Zahlungsart, z. B. Banküberweisung vor
                        Schlüsselübergabe. Sobald das Geld eingegangen ist,
                        übergibst du:
                        <ul className="custom-unordered-list secondary">
                          <li>Abmeldebestätigung</li>
                          <li>Fahrzeugbrief und -schein</li>
                          <li>Alle Schlüssel und Papiere</li>
                        </ul>
                        Lass dir den Empfang quittieren. Du solltest zusätzlich
                        deine Versicherung informieren, falls noch Restansprüche
                        bestehen.
                      </li>
                    </ol>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage2}
                revert
                h2
                isBig
                fontSize="36px"
                title="Tipps für einen erfolgreichen Verkauf"
                alt="Tipps fuer den Verkauf eines abgemeldeten Autos"
                text={
                  <>
                    <ul className="custom-unordered-list secondary">
                      <li>
                        <strong>Preisgestaltung:</strong> Setze den Preis
                        angesichts des Mehraufwands für den Käufer etwas
                        niedriger an, um den fehlenden Fahrkomfort zu
                        kompensieren.
                      </li>
                      <li>
                        <strong>Transportservice anbieten:</strong> Wenn du den
                        Transport organisierst, erhöht das die Attraktivität.
                      </li>
                      <li>
                        <strong>Ehrlichkeit:</strong> Vermeide juristische
                        Auseinandersetzungen, indem du Mängel dokumentiert
                        schriftlich festhältst.
                      </li>
                      <li>
                        <strong>Fristen setzen:</strong> Vereinbare im
                        Kaufvertrag, bis wann der Käufer das Fahrzeug überführen
                        muss.
                      </li>
                      <li>
                        <strong>Bewertungstermin vereinbaren:</strong> Viele
                        Händler führen eine Vor-Ort-Bewertung durch. So sparst
                        du Zeit.
                      </li>
                    </ul>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="Häufig gestellte Fragen"
              fragen={fragenAutoOhneZulassungVerkaufen}
              image={FAQImage}
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Auto ohne Zulassung verkaufen"
                kaputtesAuto
                unfallAuto
                autoExport
                autoVerkaufen
                autoBewerten
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit zum Thema Auto ohne Zulassung verkaufen"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos ihr Auto zu verkaufen."
                text={
                  <>
                    <p>
                      Der Verkauf eines abgemeldeten Autos erfordert Planung,
                      bietet aber klare Vorteile: Du bist direkt nach dem
                      Verkauf von allen Verpflichtungen befreit und sparst
                      laufende Kosten. Beachte jedoch, dass du potentiellen
                      Käufern entgegenkommen musst – durch transparente Angaben,
                      angemessene Preisgestaltung und Unterstützung bei
                      Transport oder Dokumenten. Wenn du den Aufwand minimieren
                      möchtest, bietet Autoeinfachlos einen komfortablen Weg:
                      Wir organisieren Transport und Abmeldung und sorgen dafür,
                      dass du dein Fahrzeug zum bestmöglichen Preis verkaufen
                      kannst.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default AutoOhneZulassungVerkaufen;
